"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("./Utils");
var NumberValidator = /** @class */ (function () {
    function NumberValidator() {
    }
    NumberValidator.validate = function (value, config, name, compare) {
        var valueWithCommasReplacedByDots = String(value).replace(/,/g, '.');
        if (!Utils_1.isDefined(config[name]))
            return false;
        var limitWithCommasReplacedByDots = String(config[name]).replace(/,/g, '.');
        var valueAsNumber = parseFloat(valueWithCommasReplacedByDots.replace(/ /g, ''));
        var limitAsNumber = parseFloat(limitWithCommasReplacedByDots.replace(/ /g, ''));
        if (isNaN(limitAsNumber))
            throw new Error("config." + name + " must be a number");
        if (value === '')
            return true;
        if (isNaN(valueAsNumber))
            return false;
        return compare(valueAsNumber, limitAsNumber);
    };
    return NumberValidator;
}());
exports.NumberValidator = NumberValidator;
//# sourceMappingURL=NumberValidator.js.map